import { IAddNotificationPayload } from '@/types/payload';
import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getWebNotificationList = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/web-notification/admin${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const getNotificationList = async (query?: Record<string, unknown>) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/notification${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const createNotification = async (data: IAddNotificationPayload) => {
  return serviceHelper(http.post('/admin/notification', data));
};

export const updateNotification = async (
  id: string,
  data: IAddNotificationPayload
) => {
  return serviceHelper(http.patch(`/admin/notification/${id}`, data), true);
};

export const deleteNotification = async (id: string | number) => {
  return serviceHelper(http.delete(`/admin/notification/${id}`), true);
};

export const clearWebNotifications = async () => {
  return serviceHelper(http.delete('/web-notification/admin/clear'), false);
};

export const markWebNotificationRead = async (id: string) => {
  return serviceHelper(http.patch(`/web-notification/admin/${id}/read`), false);
};

export const getNotificationById = async (id: string | number) => {
  return serviceHelper(http.get(`/admin/notification/${id}`), false);
};
